import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "title-container" }
const _hoisted_3 = { class: "content-container" }
const _hoisted_4 = { class: "filter-container" }
const _hoisted_5 = { class: "dataTable" }
const _hoisted_6 = { class: "container-modal" }
const _hoisted_7 = { class: "text-right margin-top-bottom-10px" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "text-right margin-top-bottom-10px" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReglePastille = _resolveComponent("ReglePastille")!
  const _component_Filter = _resolveComponent("Filter")!
  const _component_BorderedIconButton = _resolveComponent("BorderedIconButton")!
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ButtonBlue = _resolveComponent("ButtonBlue")!
  const _component_ModalCard = _resolveComponent("ModalCard")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_WaitingModal = _resolveComponent("WaitingModal")!
  const _component_SuccessModal = _resolveComponent("SuccessModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('reclamation.suivi.title')), 1),
        _createVNode(_component_ReglePastille, { cle: "suiviReclamation.definition" })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Filter, {
            onSearch: _ctx.doFilter,
            onAddFilterStatus: this.addFilterStatus,
            onRemoveFilterStatus: this.removeFilterStatus,
            onClearFilter: this.clearFilter,
            onStatusToggleSelectAll: this.statusToggleSelectAll,
            filter: this.filter,
            statusList: this.statusList,
            searchSite: _ctx.searchSite
          }, null, 8, ["onSearch", "onAddFilterStatus", "onRemoveFilterStatus", "onClearFilter", "onStatusToggleSelectAll", "filter", "statusList", "searchSite"]),
          _createVNode(_component_ReglePastille, { cle: "suiviReclamation.filtreStatut" })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", null, [
            _createElementVNode("h2", null, _toDisplayString(_ctx.$tc('reclamation.suivi.dataTable.title', +_ctx.count)), 1),
            (!_ctx.isExportDisabled)
              ? (_openBlock(), _createBlock(_component_BorderedIconButton, {
                  key: 0,
                  class: "button-xls",
                  onClick: _ctx.exportXls,
                  imgUrl: _ctx.iconeXls,
                  title: _ctx.$t('list.export')
                }, null, 8, ["onClick", "imgUrl", "title"]))
              : _createCommentVNode("", true),
            _createVNode(_component_ReglePastille, { cle: "suiviReclamation.export" })
          ]),
          (_ctx.tableData.length === 0 && _ctx.isLoading)
            ? (_openBlock(), _createBlock(_component_LoaderComponent, {
                key: 0,
                class: "loader"
              }))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                ref: "content",
                onScroll: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args))),
                class: "datatable-container"
              }, [
                _createVNode(_component_DataTable, {
                  tableData: this.tableData,
                  tableHeader: this.tableHeader,
                  isLoading: _ctx.isLoading,
                  noDataText: _ctx.$t('search.notFound'),
                  onSort: _ctx.doSort,
                  onSelect: _ctx.doSelect
                }, null, 8, ["tableData", "tableHeader", "isLoading", "noDataText", "onSort", "onSelect"])
              ], 544))
        ])
      ])
    ]),
    (this.isOpenHistoryModal)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 0,
          onCancel: this.historyModalCancel
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ModalCard, {
              withoutBotNav: true,
              headerTitle: _ctx.$t('reclamation.suivi.history.modal.title', { id: this.historyId }),
              activeValidate: false,
              onCancel: this.historyModalCancel
            }, {
              default: _withCtx(() => [
                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "height-1px" }, null, -1)),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_DataTable, {
                    tableHeader: this.headerHistoryTable,
                    tableData: this.dataHistoryTable,
                    noDataText: _ctx.$t('reclamation.suivi.history.modal.no.data')
                  }, null, 8, ["tableHeader", "tableData", "noDataText"]),
                  _createVNode(_component_ReglePastille, { cle: "suiviReclamation.clotureReouverture" }),
                  _createElementVNode("div", _hoisted_7, [
                    (_ctx.getHistorique.length !== 0 && _ctx.getHistorique[_ctx.dataHistoryTable.length - 1].typeActionId === 4)
                      ? (_openBlock(), _createBlock(_component_Button, {
                          key: 0,
                          "on-click": _ctx.reouvrir,
                          text: _ctx.$t('reclamation.suivi.history.modal.reouvrir')
                        }, null, 8, ["on-click", "text"]))
                      : _createCommentVNode("", true),
                    (_ctx.getHistorique.length === 0 || _ctx.getHistorique[_ctx.dataHistoryTable.length - 1].typeActionId !== 4)
                      ? (_openBlock(), _createBlock(_component_Button, {
                          key: 1,
                          "on-click": _ctx.cloturer,
                          text: _ctx.$t('reclamation.suivi.history.modal.cloturer')
                        }, null, 8, ["on-click", "text"]))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.afficherChampsReouverture)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createTextVNode(_toDisplayString(_ctx.$t('reclamation.suivi.history.modal.motif.reouverture')) + " ", 1),
                        _createElementVNode("div", null, [
                          _withDirectives(_createElementVNode("textarea", {
                            cols: "75",
                            rows: "10",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.motifReouverture) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.motifReouverture]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                          _createVNode(_component_Button, {
                            "on-click": _ctx.annulerReouverture,
                            text: _ctx.$t('reclamation.suivi.history.modal.annuler'),
                            class: "width-75px margin-10px"
                          }, null, 8, ["on-click", "text"]),
                          _createVNode(_component_ButtonBlue, {
                            "on-click": _ctx.reouvrirReclamation,
                            text: _ctx.$t('reclamation.suivi.history.modal.valider'),
                            class: "width-75px"
                          }, null, 8, ["on-click", "text"])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["headerTitle", "onCancel"])
          ]),
          _: 1
        }, 8, ["onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.isExportXlsLoading || _ctx.isClaimSending)
      ? (_openBlock(), _createBlock(_component_WaitingModal, { key: 1 }))
      : _createCommentVNode("", true),
    (_ctx.success)
      ? (_openBlock(), _createBlock(_component_SuccessModal, {
          key: 2,
          onCancel: _ctx.exit,
          subtitle: _ctx.$t('intervention.success.subtitle'),
          title: _ctx.response
        }, null, 8, ["onCancel", "subtitle", "title"]))
      : _createCommentVNode("", true)
  ], 64))
}